/**
 @Developper: BenAli Faker
 @Company: SMART-INFO
 @Post: CTO
 @Date:19/06/2021
 @Time:08:53
 **/
//gallery
/***************************masnory gallery********************************/
// utiliser jquery bridget pour utiliser Masonry et Isotope comme jquery
import Masonry from "masonry-layout"
import Isotope from 'isotope-layout';
jQueryBridget( 'isotope', Isotope, $ );
jQueryBridget( 'masonry', Masonry, $ );
import "./animated-masonry-gallery";
/***************************end masnory gallery********************************/
import "bootstrap-slider/dist/bootstrap-slider.min";
import "flexslider/jquery.flexslider";
import "owl.carousel/dist/owl.carousel";
import "ekko-lightbox/dist/ekko-lightbox";
import "magnific-popup/dist/jquery.magnific-popup";